import React, { useEffect, useState } from 'react';

function FloatingAlerts({ error, success, info }) {
  const [isErrorHidden, setIsErrorHidden] = useState(false);
  const [isSuccessHidden, setIsSuccessHidden] = useState(false);

  useEffect(() => {
    setIsErrorHidden(false);
  }, [error]);

  useEffect(() => {
    setIsSuccessHidden(false);
  }, [success]);

  useEffect(() => {
    if (!error || isErrorHidden) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setIsErrorHidden(true);
    }, 10000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [error, isErrorHidden]);

  useEffect(() => {
    if (!success || isSuccessHidden) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setIsSuccessHidden(true);
    }, 10000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [success, isSuccessHidden]);

  const visibleError = !isErrorHidden ? error : '';
  const visibleSuccess = !isSuccessHidden ? success : '';
  const hasItems = Boolean(visibleError || visibleSuccess || info);
  if (!hasItems) {
    return null;
  }

  return (
    <div className="app-floating-alerts" aria-live="polite" aria-atomic="true">
      {info ? <div className="alert alert-info py-2 mb-2">{info}</div> : null}
      {visibleError ? (
        <div className="alert alert-danger py-2 mb-2 d-flex align-items-start justify-content-between gap-2">
          <span>{visibleError}</span>
          <button
            type="button"
            className="btn-close"
            aria-label="Close error alert"
            onClick={() => setIsErrorHidden(true)}
          ></button>
        </div>
      ) : null}
      {visibleSuccess ? (
        <div className="alert alert-success py-2 mb-0 d-flex align-items-start justify-content-between gap-2">
          <span>{visibleSuccess}</span>
          <button
            type="button"
            className="btn-close"
            aria-label="Close success alert"
            onClick={() => setIsSuccessHidden(true)}
          ></button>
        </div>
      ) : null}
    </div>
  );
}

export default FloatingAlerts;
